<template>
    <router-link :to="{ name:options.route_name,params:{...params},query:{...query}}" class="px-1" v-bind:class="[options.color_class?options.color_class:'text-info']" v-b-tooltip.hover="{ animation: false}" :title="$t(options.title?options.title:'crud.show')" v-can="options.can">
        <i class="" v-bind:class="[options.icon?options.icon:'fas fa-eye']"></i>
    </router-link>
</template>


<script>
    export default {
        name: "TableItemActionsShow",
        props: {
            options: {
                default:function(){
                    return {};
                }
            },
            params:{
                type:Object,
                default:function(){
                    return {};
                }
            },
            query:{
                type:Object,
                default:function(){
                    return {};
                }
            },
            itemID:{}
        },
        data(){
            return {

            }
        }
    }
</script>

<style scoped>

</style>
